import { render } from "./userChat.vue?vue&type=template&id=68c393de&scoped=true"
import script from "./userChat.vue?vue&type=script&lang=js"
export * from "./userChat.vue?vue&type=script&lang=js"

import "./userChat.vue?vue&type=style&index=0&id=68c393de&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68c393de"]])

export default __exports__